import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { InverterBrand } from '../types';

class InverterBrandsService {
  async getAllBrands(): Promise<InverterBrand[]> {
    return apiService.get<InverterBrand[]>(CR_API_ENDPOINTS.INVERTER_BRANDS);
  }

  async getBrandById(id: string): Promise<InverterBrand> {
    return apiService.get<InverterBrand>(`${CR_API_ENDPOINTS.INVERTER_BRANDS}/${id}`);
  }

  async createBrand(brandData: {
    name: string;
    inverter_type: string;
  }): Promise<InverterBrand> {
    return apiService.post<InverterBrand>(CR_API_ENDPOINTS.INVERTER_BRANDS, brandData);
  }
}

export const inverterBrandsService = new InverterBrandsService();